<template>
  <div class="admin-announces">
    <setting-common
      :title="title"
      :deleteDialogTitle="title"
      :fetch="fetchData"
      :bulkUrl="bulkUrl"
      :selection="selection"
      v-on:click-new="onClickNewButton"
      :deleteCallback="onAnnounceDeleted"
      v-on:click-help="onClickHelp"
    >
      <!--
      <el-table :data="tableData" v-loading="tableLoading" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="name" label="タイトル">
          <template slot-scope="scope">{{ scope.row.title }}</template>
        </el-table-column>
        <el-table-column prop="period_from" label="掲載開始" width="200">
          <template slot-scope="scope">{{ scope.row.period_from | sqlFormatDate }}</template>
        </el-table-column>
        <el-table-column prop="period_to" label="掲載終了" width="200">
          <template slot-scope="scope">{{ scope.row.period_to | sqlFormatDate }}</template>
        </el-table-column>
        <el-table-column prop="hidden" label="非表示" width="100">
          <template slot-scope="scope">
            <i v-if="scope.row.hidden === true" class="fa fa-2x fa-minus-circle"></i>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button icon="el-icon-edit" size="small" @click="onClickEditButton(scope.row.id)">編集</el-button>
          </template>
        </el-table-column>
      </el-table>
      -->
      <el-alert v-if="isAlert" :title="errorMessage" type="error" show-icon :closable="false"></el-alert>

      <draggable
        class="list-group"
        element="ul"
        v-model="tableData"
        v-on:end="onAnnounceMoved"
        :options="{ animation: 200, delay: 10, disabled: false }"
      >
        <transition-group type="transition" :name="'flip-list'">
          <div v-for="element in tableData" :key="element.id" :loading="listLoading">
            <el-card class="announce-list" shadow="hover">
              <div class="announce-item">
                <el-col :span="1">
                  <el-checkbox @change="onAnnounceChoose(element)"></el-checkbox>
                </el-col>
                <!--
                <el-col :span="1">
                  <span class="badge">{{element.display_order}}</span>
                </el-col>
                -->
                <el-col :span="9">{{element.title}}</el-col>
                <el-col
                  :span="9"
                >{{element.period_from | sqlFormatDate}} - {{element.period_to | sqlFormatDate}}</el-col>
                <el-col :span="2">
                  <i
                    v-bind:style="element.hidden === true ? '' : 'visibility:hidden' "
                    class="fa fa-1x fa-eye-slash"
                  ></i>
                </el-col>
                <el-col :span="2">
                  <el-button
                    icon="el-icon-edit"
                    size="small"
                    @click="onClickEditButton(element.id)"
                  >編集</el-button>
                  <!--<el-button icon="el-icon-delete" size="small" type="danger" @click="onClickDeleteButton">削除</el-button>-->
                </el-col>
              </div>
            </el-card>
          </div>
        </transition-group>
      </draggable>
    </setting-common>

    <el-dialog :title="dialog.title" :visible.sync="dialog.visible" :close-on-click-modal="false">
      <el-form
        :ref="refs.form"
        :model="form"
        :label-width="formLabelWidth"
        :rules="dialogFormRules"
        @submit.prevent.native="handleRegister"
      >
        <el-form-item label="タイトル" prop="title">
          <el-input v-model="form.title" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="お知らせ本文" prop="body">
          <el-input type="textarea" :rows="10" v-model="form.body" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="掲載開始日" prop="period_from">
          <el-date-picker v-model="form.period_from" type="datetime" placeholder="掲載開始日を指定します"></el-date-picker>
        </el-form-item>
        <el-form-item label="掲載終了日" prop="period_to">
          <el-date-picker v-model="form.period_to" type="datetime" placeholder="掲載終了日を指定します"></el-date-picker>
        </el-form-item>
        <el-form-item label="非表示" prop="hidden">
          <el-checkbox v-model="form.hidden">このお知らせを表示しない（掲載期間中でも非表示）</el-checkbox>
        </el-form-item>
      </el-form>
      <el-alert
        v-if="dialog.isAlert"
        :title="dialog.errorMessage"
        type="error"
        show-icon
        :closable="false"
      ></el-alert>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleRegister" :loading="dialog.loading">OK</el-button>
        <el-button @click="handleRegisterCancel">キャンセル</el-button>
      </span>
    </el-dialog>

    <el-dialog title="ヘルプ - 設定（お知らせ）" :visible.sync="helpDialog">
      <span>
        Topページに掲載するお知らせを管理する画面です。
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import CommonMixin from "@/components/CommonMixin.js";
import moment from "moment";
import draggable from "vuedraggable";

export default {
  mixins: [CommonMixin],
  components: {
    draggable
  },
  data() {
    return {
      title: "お知らせ",
      refs: {
        form: "adminAnnouceForm"
      },
      endpointUrl: "/api/consumers/announces/",
      bulkUrl: "/api/consumers/announces-bulk/",
      dialogFormRules: {
        title: [
          {
            required: true,
            message: "タイトルを入力してください",
            trigger: "blur"
          }
        ],
        body: [
          {
            required: true,
            message: "お知らせ本文を入力してください",
            trigger: "blur"
          }
        ],
        period_from: [
          {
            required: true,
            message: "掲載開始日を入力してください",
            trigger: "blur"
          }
        ],
        period_to: [
          {
            required: true,
            message: "掲載終了日を入力してください",
            trigger: "blur"
          }
        ]
      },
      form: {
        title: "",
        body: "",
        period_from: "",
        period_to: "",
        hidden: false
      },
      formLabelWidth: "120px",
      selectedAnnounce: [],
      displayOrders: [],
      listLoading: false,
      isAlert: false
    };
  },
  created() {
    this.selectedAnnounce = [];
    this.displayOrders = [];
    this.fetchData();
  },
  watch: {
    $route: "fetchData",
    tableData: {
      // handler: function(to, from) {
      handler: function() {
        this.calcAnnounceDisplayOrder();
      },
      deep: true
    }
  },
  methods: {
    initDialog() {
      let periodFromDefault = new Date();
      let periodToDefault = moment("9999/12/31").toDate();
      this.form = Object.assign({}, this.form, {
        title: "",
        body: "",
        period_from: periodFromDefault,
        period_to: periodToDefault,
        hidden: false
      });
      this.dialog = Object.assign({}, this.dialog, {
        isAlert: false,
        errorMessage: "",
        visible: false,
        loading: false,
        title: "",
        isEdit: false
      });
    },
    onAnnounceChoose(element) {
      console.log("onAnnounceChoose");
      console.log(element);

      let announce = this.selectedAnnounce.filter(function(item, index, array) {
        if (item.id === this["id"]) {
          array.splice(index, 1);
          return true;
        } else {
          return false;
        }
      }, element);

      if (announce.length === 0) {
        this.selectedAnnounce.push(element);
      }
      this.handleSelectionChange(this.selectedAnnounce);
    },
    onAnnounceMoved(evt) {
      console.log("onAnnounceMoved");
      console.log(evt);

      this.listLoading = true;
      this.isAlert = false;
      this.errorMessage = "";

      // 入れ替えたらevtのnewIndexとoldIndexが違う値になるから、そこが一緒だったら入れ替えてないと判断して更新しない
      if (evt.newIndex !== evt.oldIndex) {
        axios
          .put(`/api/admin/announces-bulk/`, this.displayOrders)
          .then(response => {
            console.log("put announce OK");
            console.log(response);
            this.listLoading = false;
          })
          .catch(error => {
            console.log(error);
            this.isAlert = true;
            this.errorMessage = "更新に失敗しました(" + error + ")";
          });
      }
    },
    onAnnounceDeleted() {
      console.log("onAnnounceDeleted");
      this.selectedAnnounce = [];
      this.handleSelectionChange(this.selectedAnnounce);
    },
    calcAnnounceDisplayOrder() {
      console.log("calcAnnounceDisplayOrder");
      for (let i = 0; i < this.tableData.length; i++) {
        // this.tableData[i]['display_order'] = i + 1
        this.displayOrders[i] = {
          id: this.tableData[i]["id"],
          display_order: this.tableData.length - i
        };
      }
    }
  }
};
</script>

<style scoped>
.admin-announces >>> .input-search {
  display: none;
}

.announce-list {
  width: 100%;
  height: 55px;
  min-height: 55px;
  margin: 5px 0px 5px 0px;
  position: relative;
}

.announce-list .announce-item {
  width: 100%;
  line-height: 55px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
</style>
